import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import type { ShellNavItem } from "./navigation";

interface PageSearchProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  items: ShellNavItem[];
  linkState?: unknown;
}

export const PageSearch = ({ open, onOpenChange, items, linkState }: PageSearchProps) => {
  const navigate = useNavigate();
  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Where would you like to go?" />
      <CommandList>
        <CommandEmpty>No pages match.</CommandEmpty>
        <CommandGroup heading="Pages">
          {items.map((item) => (
            <CommandItem
              key={item.to}
              value={item.label}
              onSelect={() => {
                onOpenChange(false);
                navigate(item.to, { state: linkState });
              }}
              className="gap-3 py-2.5"
            >
              <item.icon className="w-4 h-4 text-muted-foreground" />
              {item.label}
              <ChevronRight className="ml-auto w-3.5 h-3.5 text-muted-foreground" />
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
};
